'use client'

import dynamic from 'next/dynamic'

import type { ModelsPlatformStatsResponse } from '@/api/generated-api'
import { useAuthStore } from '@/stores/authStore'

const HomeHeroIntroAuthSwap = dynamic(
  () =>
    import('./HomeHeroIntroAuthSwap').then(
      module => module.HomeHeroIntroAuthSwap
    ),
  { ssr: false }
)

type HomeHeroIntroAuthSwapLazyProps = {
  initialIsClubUser: boolean
  initialStats?: ModelsPlatformStatsResponse
}

export default function HomeHeroIntroAuthSwapLazy({
  initialIsClubUser,
  initialStats
}: HomeHeroIntroAuthSwapLazyProps) {
  // Auth store is seeded from the token on the client, so no effect/setState
  // is needed to decide when to mount the authenticated hero swap.
  const isAuthenticated = useAuthStore(s => s.isAuthenticated)

  if (!isAuthenticated) {
    return null
  }

  return (
    <HomeHeroIntroAuthSwap
      initialIsClubUser={initialIsClubUser}
      initialStats={initialStats}
    />
  )
}
